import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, useResource, type RouteResource } from '@atlassian/react-resource-router';
import type {
	UseNavigationPlansVisibility,
	UseNavigationViewPlansPermission,
	NavigationPlansVisibilityResponseData,
	UseNavigationEditPlansPermission,
	UseIsAdvancedRoadmapsTrial,
} from './UseNavigationPlansVisibility.types.tsx';

const RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY = 'NAVIGATION_PLANS_VISIBILITY';
const LOCATION = 'portfolio.services.plan-item-visibility';

export const navigationPlansVisibilityResource: RouteResource<
	false | NavigationPlansVisibilityResponseData
> = createResource<NavigationPlansVisibilityResponseData | false>({
	type: RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY,
	getKey: () => 'state',
	getData: async (_, { tenantContext }): Promise<NavigationPlansVisibilityResponseData | false> => {
		try {
			if (tenantContext.isAnonymous) {
				return false;
			}

			const response = await fetchJson('/rest/jpo/1.0/navigation/simple');

			return response;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			log.safeErrorWithoutCustomerData(LOCATION, 'Error while fetching plans visibility', error);
		}
		return false;
	},
	maxAge: Infinity,
	isCritical: true,
});

export const useNavigationPlansVisibility: UseNavigationPlansVisibility = () => {
	const { data, loading, error } = useResource(navigationPlansVisibilityResource);

	let isVisible = false;

	if (!error && !loading && data !== null && typeof data === 'object') {
		isVisible = data.isVisible;
	}

	return [isVisible];
};

export const useNavigationViewPlansPermission: UseNavigationViewPlansPermission = () => {
	const { data, loading, error } = useResource(navigationPlansVisibilityResource);

	let hasEditOrViewPermissions = false;

	if (!error && !loading && data !== null && typeof data === 'object') {
		hasEditOrViewPermissions = data.hasEditOrViewPermissions;
	}

	return [hasEditOrViewPermissions];
};

export const useNavigationEditPlansPermission: UseNavigationEditPlansPermission = () => {
	const { data, loading, error } = useResource(navigationPlansVisibilityResource);

	let canEditPlans = false;

	if (!error && !loading && data !== null && typeof data === 'object') {
		canEditPlans = data.hasEditPermissions || false;
	}

	return canEditPlans;
};

export const useIsAdvancedRoadmapsTrial: UseIsAdvancedRoadmapsTrial = () => {
	const { data, loading, error } = useResource(navigationPlansVisibilityResource);

	let isAdvancedRoadmapsTrial = false;

	if (!error && !loading && data !== null && typeof data === 'object') {
		isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
	}

	return isAdvancedRoadmapsTrial;
};
